import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ProfileRoutingModule } from "./profile-routing.module";
import { ProfileComponent } from "./profile.component";
import { ViewProfileComponent } from "./view-profile/view-profile.component";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { MaterialModule } from "src/app/shared/material.module";
import { SharedModule } from "src/app/shared/shared.module";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ProfilePicComponent } from "./profile-pic/profile-pic.component";
import { OnlyNumberDirective } from "./directives/only-number.directive";
import { OnlyCharacterDirective } from "./directives/only-character.directive";
import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
  declarations: [
    ProfileComponent,
    ViewProfileComponent,
    EditProfileComponent,
    ChangePasswordComponent,
    ProfilePicComponent,
    OnlyNumberDirective,
    OnlyCharacterDirective,
  ],
  imports: [
    CommonModule,
    ProfileRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule
  ],
  exports: [ProfilePicComponent],
})
export class ProfileModule {}
